import React from "react";
import semanticVariables from "ui-v2/styles/semantic_colors.module.scss";

export default ({ width = 24, height = 24, color = "primary" }) => {
  const colorValue = semanticVariables?.[`semantic_icon_${color}`];
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.63388 16.6339C7.14573 17.122 6.35427 17.122 5.86611 16.6339L2.11612 12.8839C1.62796 12.3957 1.62796 11.6043 2.11612 11.1161L5.86612 7.36612C6.35427 6.87796 7.14573 6.87796 7.63388 7.36612C8.12204 7.85427 8.12204 8.64573 7.63388 9.13388L6.01777 10.75L21 10.75C21.6904 10.75 22.25 11.3096 22.25 12C22.25 12.6904 21.6904 13.25 21 13.25L6.01777 13.25L7.63388 14.8661C8.12204 15.3543 8.12204 16.1457 7.63388 16.6339Z"
        fill={colorValue}
      />
    </svg>
  );
};
